import React from 'react'
import { useTranslation } from 'react-i18next'

export default function PrivatePolicyView() {
	const { t } = useTranslation()

	return (
		<div className='flex min-h-screen w-full flex-col'>
			<div className='min-h-screen bg-background text-foreground selection:bg-primary/30'>
				<main className='container mx-auto px-4 pt-20 pb-12 md:pt-24 md:pb-20 max-w-3xl'>
					<div className='space-y-4 mb-12'>
						<h1 className='text-3xl md:text-5xl font-extrabold tracking-tight'>{t('privacy.title')}</h1>
						<p className='text-muted-foreground'>{t('privacy.lastUpdated')}</p>
					</div>

					<div className='space-y-8 text-foreground/80 leading-relaxed'>
						{/* Intro */}
						<section className='space-y-4'>
							<p>{t('privacy.intro.p1')}</p>
							<p>{t('privacy.intro.p2')}</p>
						</section>

						{/* Автоматический сбор информации */}
						<section className='space-y-4'>
							<h2 className='text-2xl font-bold text-foreground'>{t('privacy.autoCollection.title')}</h2>
							<p>{t('privacy.autoCollection.p1')}</p>
							<p>{t('privacy.autoCollection.p2')}</p>
						</section>

						{/* Сбор личной информации */}
						<section className='space-y-4'>
							<h2 className='text-2xl font-bold text-foreground'>{t('privacy.personalInfo.title')}</h2>
							<p>{t('privacy.personalInfo.p1')}</p>
							<p>{t('privacy.personalInfo.p2')}</p>
							<ul className='list-disc pl-6 space-y-2 text-muted-foreground'>
								{[0, 1, 2, 3, 4].map(i => (
									<li key={i}>{t(`privacy.personalInfo.items.${i}`)}</li>
								))}
							</ul>
							<p>{t('privacy.personalInfo.p3')}</p>
						</section>

						{/* Конфиденциальность детей */}
						<section className='space-y-4'>
							<h2 className='text-2xl font-bold text-foreground'>{t('privacy.children.title')}</h2>
							<p>{t('privacy.children.p1')}</p>
							<p>{t('privacy.children.p2')}</p>
						</section>

						{/* Использование и обработка */}
						<section className='space-y-4'>
							<h2 className='text-2xl font-bold text-foreground'>{t('privacy.useAndProcessing.title')}</h2>
							<p>{t('privacy.useAndProcessing.p1')}</p>
							<p>{t('privacy.useAndProcessing.p2')}</p>
							<p>{t('privacy.useAndProcessing.p3')}</p>
							<p>{t('privacy.useAndProcessing.p4')}</p>
							<ul className='list-disc pl-6 space-y-2 text-muted-foreground'>
								{[0, 1, 2, 3].map(i => (
									<li key={i}>{t(`privacy.useAndProcessing.items.${i}`)}</li>
								))}
							</ul>
							<p>{t('privacy.useAndProcessing.p5')}</p>
							<p>{t('privacy.useAndProcessing.p6')}</p>
						</section>

						{/* Управление информацией */}
						<section className='space-y-4'>
							<h2 className='text-2xl font-bold text-foreground'>{t('privacy.managingInfo.title')}</h2>
							<p>{t('privacy.managingInfo.p1')}</p>
						</section>

						{/* Раскрытие информации */}
						<section className='space-y-4'>
							<h2 className='text-2xl font-bold text-foreground'>{t('privacy.disclosure.title')}</h2>
							<p>{t('privacy.disclosure.p1')}</p>
							<p>{t('privacy.disclosure.p2')}</p>
						</section>

						{/* Сохранение информации */}
						<section className='space-y-4'>
							<h2 className='text-2xl font-bold text-foreground'>{t('privacy.retention.title')}</h2>
							<p>{t('privacy.retention.p1')}</p>
							<p>{t('privacy.retention.p2')}</p>
						</section>

						{/* Push-уведомления */}
						<section className='space-y-4'>
							<h2 className='text-2xl font-bold text-foreground'>{t('privacy.pushNotifications.title')}</h2>
							<p>{t('privacy.pushNotifications.p1')}</p>
						</section>

						{/* Ссылки на другие ресурсы */}
						<section className='space-y-4'>
							<h2 className='text-2xl font-bold text-foreground'>{t('privacy.links.title')}</h2>
							<p>{t('privacy.links.p1')}</p>
						</section>

						{/* Информационная безопасность */}
						<section className='space-y-4'>
							<h2 className='text-2xl font-bold text-foreground'>{t('privacy.security.title')}</h2>
							<p>{t('privacy.security.p1')}</p>
							<p>{t('privacy.security.p2')}</p>
						</section>

						{/* Нарушение безопасности данных */}
						<section className='space-y-4'>
							<h2 className='text-2xl font-bold text-foreground'>{t('privacy.dataBreach.title')}</h2>
							<p>{t('privacy.dataBreach.p1')}</p>
						</section>

						{/* Изменения и поправки */}
						<section className='space-y-4'>
							<h2 className='text-2xl font-bold text-foreground'>{t('privacy.changes.title')}</h2>
							<p>{t('privacy.changes.p1')}</p>
							<p>{t('privacy.changes.p2')}</p>
						</section>

						{/* Принятие данной политики */}
						<section className='space-y-4'>
							<h2 className='text-2xl font-bold text-foreground'>{t('privacy.acceptance.title')}</h2>
							<p>{t('privacy.acceptance.p1')}</p>
						</section>

						{/* Обращение к нам */}
						<section className='space-y-4'>
							<h2 className='text-2xl font-bold text-foreground'>{t('privacy.contact.title')}</h2>
							<p>{t('privacy.contact.p1')}</p>
							<div className='bg-muted p-6 rounded-2xl mt-4'>
								<p className='font-medium'>
									{t('privacy.contact.emailLabel')}{' '}
									<a href='mailto:openraystech@gmail.com' className='text-primary hover:underline'>
										openraystech@gmail.com
									</a>
								</p>
							</div>
							<p>{t('privacy.contact.p2')}</p>
						</section>

						<p className='text-muted-foreground text-sm'>{t('privacy.documentUpdated')}</p>
					</div>
				</main>

				<footer className='border-t border-border/40 py-8 text-center text-muted-foreground text-sm'>
					<p>
						&copy; {new Date().getFullYear()} {t('privacy.footerCopyright')}
					</p>
				</footer>
			</div>
		</div>
	)
}
